import { defineMessages } from 'react-intl-next';

export default defineMessages({
	browseAgentsPillLabel: {
		id: 'ai-mate.rovo-agent-components.browse-agents-pill.label',
		defaultMessage: 'Browse Agents',
		description: 'The label displayed on the browse agents pill',
	},
});
